/** Datos guardados en sessionStorage tras el pago (one-step / payment-return). */

export interface ConfirmRoomData {
  id?: number
  info?: { name?: string }
}

export interface ConfirmHotelData {
  id?: number
  name?: string
  address?: string
  city?: string
  chain?: string
  stars?: { abbr?: string }
  images?: string[]
  latitude?: string
  longitude?: string
}

export interface ConfirmPriceData {
  priceRoom?: string
  fee?: string
  destination?: string | number
  now?: string
  total?: number
  totalBase?: number
  totalFormat?: string
  destinationFormat?: string
  specificTaxes?: string
  specificTaxesNum?: number
  specificTaxesList?: Array<{ label?: string; amountFormat?: string }>
}

export interface ConfirmPromoData {
  applied?: boolean
  code?: string
  discountFormatted?: string
}

export interface ConfirmBookingExtra {
  id?: number
  name?: string
  quantity?: number
  price?: string
}

export interface ConfirmBookingData {
  timestamp: number
  hotelData?: ConfirmHotelData
  roomData?: ConfirmRoomData
  priceData?: ConfirmPriceData
  date?: string
  packhour?: number
  hour?: string
  extraHours?: number
  numRooms?: number
  totalAmount?: string | number
  currency?: string
  eur_exchange?: number
  reference?: string
  booking_code?: string
  confirmed?: boolean
  holderFirstName?: string
  holderLastName?: string
  holderEmail?: string
  holderPhone?: string
  comments?: string
  promoData?: ConfirmPromoData | null
  extrasData?: ConfirmBookingExtra[]
}

export function isConfirmBookingData(value: unknown): value is ConfirmBookingData {
  if (typeof value !== 'object' || value === null) return false
  const ts = (value as { timestamp?: unknown }).timestamp
  return typeof ts === 'number'
}
